import { Stack } from "@mui/material";
import ServicePicker from "@/components/ServicePicker";
import { useFormikContext } from "formik";
import { Branch } from "@/types/branch";

const ServicesView = () => {
    const { values, setFieldValue } = useFormikContext<Branch>();

    return (
        <Stack spacing={2} p={2}>
            <ServicePicker
                multiple={true}
                value={values.services ?? []}
                onChange={(services) => setFieldValue("services", services)}
            />
        </Stack>
    )
}

export default ServicesView;
